import { Location, useLocation, useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { InvitationPageContextAPI, InvitationPageContextState } from './InvitationPageContext';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import InviteCandidatesPageRouteParams from '../Utils/InviteCandidatesPageRouteParams';
import { useAssessmentClient, useJobAdClient } from '@/Hooks/ClientHooks';
import RoutePath from '@/Routing/RoutePath';
import { InviteApplicantsPageLocationState } from '../InviteCandidatesPage';

function useInvitationPageContextValue(): InvitationPageContextAPI {
    // https://github.com/remix-run/react-router/pull/7326#issuecomment-626418225
    const location = useLocation() as Location<InviteApplicantsPageLocationState>;
    const [state, setState] = useState<InvitationPageContextState>({
        specsLoading: true,
        jobAdIdLoading: true,
        jobAdId: '',
        recruitmentName: '',
        recruitmentStatus: AssessmentStatuses.Active,
        clientId: '',
        returnURL: location?.state?.from,
    });

    const { specsLoading, jobAdIdLoading, jobAdId, recruitmentName, recruitmentStatus, clientId, returnURL } = state;

    const { recruitmentId } = useParams<Partial<InviteCandidatesPageRouteParams>>();
    const recruitmentClient = useAssessmentClient();
    const jobAdClient = useJobAdClient();

    useEffect(() => {
        if (recruitmentId) {
            const doLoadRecruitmentSpecification = async () => {
                const specification = await recruitmentClient.getSpecificationAsync(recruitmentId);
                setState((prevState) => ({
                    ...prevState,
                    specsLoading: false,
                    recruitmentName: specification.name,
                    recruitmentStatus: specification.assessmentStatus,
                    clientId: specification.clientId,
                }));
            };
            doLoadRecruitmentSpecification();
        }
    }, []);

    useEffect(() => {
        if (recruitmentId) {
            const doLoadJobAdId = async () => {
                try {
                    const id = await jobAdClient.getJobAdIdByRecruitmentIdAsync(recruitmentId);
                    setState((prevState) => ({
                        ...prevState,
                        jobAdIdLoading: false,
                        jobAdId: id,
                    }));
                } catch (error) {
                    setState((prevState) => ({
                        ...prevState,
                        jobAdIdLoading: false,
                        activeTab: RoutePath.AttractApplicantsInvite,
                    }));
                }
            };
            doLoadJobAdId();
        }
    }, []);

    return {
        specsLoading,
        jobAdIdLoading,
        jobAdId,
        recruitmentName,
        recruitmentStatus,
        clientId,
        returnURL,
    };
}

export default useInvitationPageContextValue;
